const getMin2Hour = (min) => {
  // 1時間未満の場合
  if (min < 60) return min + '分'
  else return Math.floor(min / 60) + '時間' + ' ' + (min - 60 * Math.floor(min / 60)) + '分'
}

export { getMin2Hour }



// WEBPACK FOOTER //
// ./src/functions/common/taskFunc.js